<template>
  <b-row :class="level_valid_cls">
    <b-col>
      <b-form-group label="난이도*">
        <b-form-checkbox-group
          v-model="lvl_selected"
          :options="lvl_options"
          name="buttons-1"
          button-variant="info"
          buttons
        ></b-form-checkbox-group>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  computed: {
    level_valid_cls() {
      return this.$store.state.valid.level;
    },
    lvl_options() {
      return this.$store.state.lvl_options;
    },
    lvl_selected: {
      get() {
        return this.$store.state.questionform.level;
      },
      set(val) {
        this.$store.commit("updateLevel", val);
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.invalid {
  border: 2px solid red;
}
</style>